import type { TeamTileColors } from './teamVisualResolver';
import { deltaE2000 } from './ciede2000';

/**
 * Primaries closer than this are one color on a split tile.
 * 15 sits just above the navy family and the near-blacks (the widest of those,
 * Bears vs Raiders, is 12.4). The next pair, Colts vs Jaguars, is 15.01.
 */
export const TILE_CLASH_DELTA_E = 15;

export type PaintedTile = { fill: string; ink: string };

function paint(colors: TeamTileColors, useSecondary: boolean): PaintedTile {
  return useSecondary
    ? { fill: colors.secondary, ink: colors.onSecondary }
    : { fill: colors.primary, ink: colors.onPrimary };
}

/**
 * When the two primaries are too close, the home side uses its secondary.
 * If that is still too close, the away side uses its secondary as well.
 */
export function resolveTileClash(
  away: TeamTileColors | null,
  home: TeamTileColors | null
): { away: PaintedTile | null; home: PaintedTile | null; switched: 'none' | 'home' | 'both' } {
  if (!away || !home) {
    return {
      away: away ? paint(away, false) : null,
      home: home ? paint(home, false) : null,
      switched: 'none',
    };
  }
  const awayPrimary = paint(away, false);
  let homePaint = paint(home, false);
  if (deltaE2000(awayPrimary.fill, homePaint.fill) >= TILE_CLASH_DELTA_E) {
    return { away: awayPrimary, home: homePaint, switched: 'none' };
  }
  homePaint = paint(home, true);
  if (deltaE2000(awayPrimary.fill, homePaint.fill) >= TILE_CLASH_DELTA_E) {
    return { away: awayPrimary, home: homePaint, switched: 'home' };
  }
  return { away: paint(away, true), home: homePaint, switched: 'both' };
}
